import { useEffect, useState } from "react";
import { saveOfferCoupon, updateOfferCoupon } from "../../../apiService/loyalty.service";

const initialCouponForm = {
  code: "",
  coupon_type: "single_use",
};

const normalizeCouponForm = (initialValues = {}) => ({
  code: initialValues.coupon_code || initialValues.code || "",
  coupon_type: initialValues.coupon_type || initialValues.type || "single_use",
});

export const useCouponForm = ({ offerId, couponId, initialValues, onSaved }) => {
  const isEdit = Boolean(couponId);
  const [form, setForm] = useState(initialCouponForm);
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!initialValues) {
      setForm(initialCouponForm);
      return;
    }

    setForm(normalizeCouponForm(initialValues));
  }, [initialValues, couponId, isEdit, offerId]);

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFieldErrors((prev) => ({ ...prev, [name]: "" }));
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const nextFieldErrors = {};

    if (!form.code.trim()) {
      nextFieldErrors.code = "Coupon code is required.";
    }

    if (!form.coupon_type) {
      nextFieldErrors.coupon_type = "Coupon type is required.";
    }

    setFieldErrors(nextFieldErrors);

    if (Object.keys(nextFieldErrors).length > 0) {
      setError(Object.values(nextFieldErrors)[0]);
      return;
    }

    setError("");
    setIsSubmitting(true);

    try {
      const payload = {
        coupon_code: form.code.trim(),
        coupon_type: form.coupon_type,
      };

      if (isEdit) {
        payload.id = couponId || initialValues?.id || initialValues?.coupon_id || "";
        await updateOfferCoupon(payload);
      } else {
        payload.offer_id = String(offerId || "");
        await saveOfferCoupon(payload);
      }

      setFieldErrors({});
      onSaved?.();
    } catch (submitError) {
      const message =
        submitError?.response?.data?.message ||
        submitError?.message ||
        "Failed to save coupon. Please try again.";
      setError(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isEdit,
    form,
    error,
    fieldErrors,
    isSubmitting,
    handleFieldChange,
    handleSubmit,
  };
};

export default useCouponForm;
